import darkImg from "../../../Images/Images/Catalaogue/cuveJupe/dark.jpg";
import blueImg from "../../../Images/Images/Catalaogue/cuveJupe/blue.jpg";
import greyImg from "../../../Images/Images/Catalaogue/cuveJupe/grey.jpg";
import midnightImg from "../../../Images/Images/Catalaogue/cuveJupe/midnight-opal.png";
import whiteMarble from "../../../Images/Images/Catalaogue/cuveJupe/white-marble.png";
import medet from "../../../Images/Images/Catalaogue/cuveJupe/medet.png";
import marron from "../../../Images/Images/Catalaogue/cuveJupe/marron.png";
import oceanWave from "../../../Images/Images/Catalaogue/cuveJupe/ocean-wave.png";
import {
  CuveJupeIcon,
  cuveMapNames,
  jupeMapNames,
} from "../../../helpers/formLabels/cuveJupeOptions";

export const getPackingSelectValue = (approv) => {
  return (
    approv?.packingList?.map((packing) => {
      return {
        ...packing,
        model: {
          name: packing.model?.data?.attributes?.name,
          code: packing.model?.data?.id,
          productType: packing.model?.data?.attributes?.productType,
          retailerPriceHT: packing.model?.data?.attributes?.retailerPriceHT,
          publicPriceTTC: packing.model?.data?.attributes?.publicPriceTTC,
        },
        reference: packing.reference,
        cuve:
          packing?.isProduct && cuveMapNames[packing?.cuve]
            ? { name: cuveMapNames[packing?.cuve], code: packing?.cuve }
            : null,
        panel:
          packing?.isProduct && jupeMapNames[packing?.panel]
            ? { name: jupeMapNames[packing?.panel], code: packing?.panel }
            : null,
      };
    }) || []
  );
};
